import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  ElementRef,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  PLATFORM_ID
} from '@angular/core';
import { UserDataService, UserSessionService } from '@com-delta-idp/mnx-oauth';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataLayer } from '../../common/datalayer/datalayer';
import { ApplicationConfig } from '../../config/config';
import { SwitchingAccountService } from '../../header/switching-account/switching-account.service';
import { AcctactvtyTracker } from '../../model/acctactvty-tracker.model';
import { AccountSummaryService } from '../../services/accountsummary/account-summary.service';
import { TrackerDataService } from '../../services/acctactvty/trackerData.service';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';
import { ErrorMessagesReducerStoreService } from '../../store/services/error-message.reducer.service';

@Component({
  selector: 'ngc-acctactvty',
  templateUrl: './acctactvty.component.html'
})
export class AcctactvtyComponent implements OnInit, OnDestroy {
  @Input() resAcctActivityContent: any;
  @Input() aemErrorMessages: any;
  @Input() isDelta: any;
  @Input() resAcctSumContent: any;
  @Input() resAcctSumDetails: any;
  @Input() showNewFlyout: any;

  showSpendRequirement: boolean;
  trackerStaticDescription: string;
  exploreSkymilesButtonLabel: string;
  exploreSkymilesLink: string;
  showStaticTracker: boolean;
  showSpendCriteria: boolean;
  showTracker: boolean;
  upcomingTracker: boolean;
  upcomingTrackerStartDate: string;
  upcomingTrackerEndDate: string;
  trackerData: AcctactvtyTracker;
  barTexts: any;
  trackerOffscreenText: any;
  mileageReqChecked: boolean;
  aemErrorResp: any;
  aemErrorMsgDetails: any;
  topAuthorMsg: any;
  dmMqdWaiver: any;
  otherMqdWaiver: any;
  dmCardSpendRangeLink: any;
  dmCardSpendRangeValue: any;
  cardSpendRangeValue: string;
  cardSpendRangeLink: any;
  futureTierLink: any;
  futureYrTier: any;
  spinner = false;
  medallionMemberDesc: any;
  currentYearTierDesc: any;
  currentYearTierCode: any;
  tierLevelMsg: any;
  availableBalanceVS: any;
  maxForCurrentTierVS: any;
  enrollmentDate: any;
  milesExpiryDate: any;
  silverThreshold: any;
  goldThreshold: any;
  redToSilverMsg: string;
  retainSilverMsg: string;
  silverToGoldMsg: string;
  retainGoldMsg: string;
  achivedGoldMsg: string;
  membershipLevel: string;
  tierPointUrl: any;
  medallionUrl: any;
  tierPointDescription: any;
  medallionDescritpion: any;
  maxThreshold: any;
  lifetimeMQM: any;
  showlifetimeStatus: boolean;
  millionMiller: any;
  contentHeaderFooterServiceSubscribe: Subscription;
  accountSummaryServiceSubscribe: Subscription;
  trackerDataServiceSubscribe: Subscription;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    public switchingAccountService: SwitchingAccountService,
    private contentService: ContentHeaderFooterService,
    private trackerDataService: TrackerDataService,
    private accountSummaryService: AccountSummaryService,
    private errorService: ErrorMessagesReducerStoreService,
    private _config: ApplicationConfig,
    @Inject(PLATFORM_ID) private platformId: Object,
    private el: ElementRef,
    private datalayer: DataLayer,
    private userSession: UserSessionService,
    private loggingService: LoggingService,
    private userData: UserDataService
  ) {
    this.showTracker = false;
    this.showSpendCriteria = false;
    this.mileageReqChecked = false;
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.contentHeaderFooterServiceSubscribe =
        this.contentService.contentHeaderFooter
          .pipe(takeUntil(this.unsubscribe))
          .subscribe((data) => {
            this.showStaticTracker =
              data?.header?.trackerStaticText?.showStaticTracker === 'true'
                ? true
                : false;
            if (this.showStaticTracker) {
              const { trackerStaticText } = data.header;
              this.showTracker = true;
              this.upcomingTracker =
                trackerStaticText?.displayUpcomingTracker === 'true'
                  ? true
                  : false;
              this.upcomingTrackerStartDate =
                trackerStaticText?.upcomingTrackerStartDate;
              this.upcomingTrackerEndDate =
                trackerStaticText?.upcomingTrackerEndDate;
              this.trackerStaticDescription = this.displayUpcomingTracker()
                ? trackerStaticText?.upcomingTrackerDescription
                : trackerStaticText?.trackerStaticDescription;
              this.exploreSkymilesButtonLabel = this.displayUpcomingTracker()
                ? trackerStaticText?.upcomingTrackerButtonLabel
                : trackerStaticText?.exploreSkymilesButtonLabel;
              this.exploreSkymilesLink = this.displayUpcomingTracker()
                ? trackerStaticText?.upcomingTrackerButtonUrl
                : trackerStaticText?.exploreSkymilesLink;
            }
          });

      if (this.userSession.getServiceWorkerCheck()) {
        this.accountSummaryServiceSubscribe = this.getAccountSummary();
      }
    }
  }

  displayUpcomingTracker(): boolean {
    if (this.upcomingTracker) {
      const startDate = new Date(this.upcomingTrackerStartDate);
      const endDate = new Date(this.upcomingTrackerEndDate);
      const currentDate = new Date();
      if (
        (currentDate === startDate || currentDate > startDate) &&
        (currentDate === endDate || currentDate < endDate)
      ) {
        return true;
      }
    }
    return false;
  }

  getAccountSummary() {
    return this.accountSummaryService
      .getAccountSummaryDetails()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (resp) => {
          this.userData.getAuthConfigContent().subscribe((response) => {
            if (response && response['ORION_FLYOUT'] === true) {
              return;
            } else {
              this.getAccountSummaryHelper(resp);
            }
          });
        },
        (err) => {
          this.loggingService.log('Caught Error: ' + err);
          this.spinner = false;
        }
      );
  }

  getAccountSummaryHelper(resp) {
    this.spinner = true;
    const resAcctSumDetails = resp;
    if (
      this.resAcctSumDetails !== null &&
      this.resAcctSumDetails !== undefined
    ) {
      this.membershipLevel = resAcctSumDetails.membershipLevel;
      const skymilesNbr = resAcctSumDetails.smNumber;
      this.medallionMemberDesc = resAcctSumDetails?.medallionMemberDesc || '';
      if (!this.isDelta) {
        this.setMemberDescription(this.resAcctSumDetails.membershipLevel);
      }
      this.currentYearTierDesc = resAcctSumDetails.currentYearTierDesc;
      this.enrollmentDate = resAcctSumDetails.enrollmentDate;
      this.milesExpiryDate = resAcctSumDetails.milesExpireDate;
      if (!this.showStaticTracker) {
        this.trackerDataServiceSubscribe = this.trackerDataService
          .getTrackerData(skymilesNbr)
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(
            (res) => {
              if (
                res.errors !== null &&
                res.errors !== undefined &&
                res.errors.length === 0
              ) {
                this.trackerData = new AcctactvtyTracker(res);
                if (!this.isDelta) {
                  if (this.trackerData) {
                    this.availableBalanceVS =
                      this.trackerData.currentYearMQS.availableBalance;
                    this.maxForCurrentTierVS =
                      this.trackerData.currentYearMQS.maxForCurrentTier;
                    this.currentYearTierCode =
                      this.trackerData.currentYearTierCode;
                    this.lifetimeMQM = this.trackerData.lifetimeMQM
                      ? parseInt(this.trackerData.lifetimeMQM)
                      : parseInt('0');
                    this.millionMiller = parseInt('1000000');
                    this.datalayer.accountActivityData = this.trackerData;
                    this.datalayer.pageInfo = this._config.get('APP_ENV');
                    this.datalayer.compile();
                    this.datalayer.init();
                  }
                  this.setTierLevelUrl();
                  this.setMedallionStatus();
                }
                this.setBarTexts();
              } else {
                this.aemErrorMsgDetails = this.aemErrorMessages
                  ? this.aemErrorMessages.get('ACCT_SYS_ERROR')
                  : 'ACCT_SYS_ERROR';
                this.removeMargin();
              }
              this.spinner = false;
            },
            (err) => {
              if (err) {
                this.removeMargin();
                this.aemErrorMsgDetails = this.aemErrorMessages
                  ? this.aemErrorMessages.get('ACCT_SYS_ERROR')
                  : 'ACCT_SYS_ERROR';
              }
              this.spinner = false;
            }
          );
      }
      this.datalayer.setDdcfbData(resAcctSumDetails);
    }
  }

  setMemberDescription(medFlag: string) {
    if (this.resAcctActivityContent?.medallion?.length > 0) {
      this.resAcctActivityContent.medallion.forEach((tierLevel) => {
        if (tierLevel?.medallionId === medFlag) {
          this.medallionMemberDesc = tierLevel.medallionLabel;
        }
      });
    }
  }

  /* Medallion logic*/
  setMedallionStatus() {
    let thresholdValue;
    let thresholdMsg;
    const silverThreshold = this.getThreshHoldValue(
      this.resAcctSumContent.silverThreshold
    );
    const goldhreshold = this.getThreshHoldValue(
      this.resAcctSumContent.goldThreshold
    );

    if (this.currentYearTierCode) {
      if (this.currentYearTierCode === 'FF') {
        if (this.availableBalanceVS > silverThreshold) {
          this.maxThreshold = silverThreshold;
        } else {
          thresholdValue = silverThreshold - this.availableBalanceVS;
          thresholdMsg =
            thresholdValue + ' ' + this.resAcctSumContent.redToSilverMsg;
        }
        this.maxThreshold = silverThreshold;
      } else if (this.currentYearTierCode === 'FO') {
        if (this.availableBalanceVS < silverThreshold) {
          thresholdValue =
            this.resAcctSumContent.silverThreshold - this.availableBalanceVS;
          thresholdMsg =
            thresholdValue + ' ' + this.resAcctSumContent.retainSilverMsg;
          this.maxThreshold = silverThreshold;
        } else if (
          silverThreshold <= this.availableBalanceVS &&
          this.availableBalanceVS < goldhreshold
        ) {
          thresholdValue =
            this.resAcctSumContent.goldThreshold - this.availableBalanceVS;
          thresholdMsg =
            thresholdValue + ' ' + this.resAcctSumContent.silverToGoldMsg;
          this.maxThreshold = goldhreshold;
        }
      } else if (this.currentYearTierCode === 'GM') {
        if (this.availableBalanceVS < goldhreshold) {
          thresholdValue =
            this.resAcctSumContent.goldThreshold - this.availableBalanceVS;
          thresholdMsg =
            thresholdValue + ' ' + this.resAcctSumContent.retainGoldMsg;
          this.maxThreshold = goldhreshold;
        } else if (
          this.availableBalanceVS >= goldhreshold &&
          this.lifetimeMQM <= this.millionMiller
        ) {
          thresholdValue = this.availableBalanceVS;
          thresholdMsg = ' ' + this.resAcctSumContent.achivedGoldMsg;
          this.maxThreshold = goldhreshold;
        } else if (this.lifetimeMQM > this.millionMiller) {
          thresholdValue = ' ';
          thresholdMsg = ' ';
          this.showlifetimeStatus = true;
        }
      }
      this.tierLevelMsg = thresholdMsg;
    }
  }

  getThreshHoldValue(threshHoldStr) {
    const thresholdValue =
      threshHoldStr !== undefined && threshHoldStr !== ''
        ? parseInt(threshHoldStr)
        : 0;
    return thresholdValue;
  }

  setTierLevelUrl() {
    if (this.resAcctActivityContent?.medallion?.length > 0) {
      this.resAcctActivityContent.medallion.forEach((tierLevel) => {
        if (
          tierLevel.medallionUrl &&
          tierLevel.medallionId === this.currentYearTierCode
        ) {
          this.medallionUrl = tierLevel.medallionUrl;
          this.medallionDescritpion = tierLevel.medallionDescription;
          this.tierPointUrl = tierLevel.tierPointUrl;
          this.tierPointDescription = tierLevel.tierPointDescription;
        }
      });
    }
  }

  getClassNamesVS(medFlag: string) {
    if (!medFlag) {
      return;
    }
    const flags = {
      FF: 'va-tier-color-ff',
      FO: 'va-tier-color-sm',
      GM: 'va-tier-color-gm'
    };
    const bgClassName = flags[medFlag] ?? 'va-tier-color-ff';
    return {
      [bgClassName]: true
    };
  }

  /*Medallion logic ends*/

  setBarTexts() {
    let cardSpendRange;
    if (this.resAcctActivityContent) {
      if (this.resAcctActivityContent?.status) {
        this.topAuthorMsg =
          this.trackerData.futureProgramYear +
          ' ' +
          this.resAcctActivityContent.status;
      }
      if (this.resAcctActivityContent?.medallion?.length > 0) {
        this.resAcctActivityContent.medallion.forEach((tierLevel) => {
          if (tierLevel.medallionId === this.trackerData.futureYearTierCode) {
            this.futureYrTier = tierLevel.medallionLabel;
            this.futureTierLink = tierLevel.medallionUrl;
          }
        });
      }
      if (this.resAcctActivityContent?.waiver) {
        if (this.resAcctActivityContent.waiver?.length > 0) {
          this.otherMqdWaiver =
            this.resAcctActivityContent?.waiver[0]?.waiverLabel ||
            'Platinum, Gold & Silver MQD Waiver:';
          if (this.resAcctActivityContent?.waiver[0]?.waiverUrl) {
            this.cardSpendRangeLink =
              this.resAcctActivityContent.waiver[0].waiverUrl;
          }
          if (this.resAcctActivityContent?.waiver[0]?.waiverPrice) {
            this.cardSpendRangeValue =
              this.resAcctActivityContent.waiver[0].waiverPrice;
          }
          if (this.resAcctActivityContent.waiver[1] !== undefined) {
            this.dmMqdWaiver =
              this.resAcctActivityContent?.waiver[1]?.waiverLabel ||
              'Diamond MQD Waiver:';
            if (this.resAcctActivityContent?.waiver[1]?.waiverUrl) {
              this.dmCardSpendRangeLink =
                this.resAcctActivityContent.waiver[1].waiverUrl;
            }
            if (this.resAcctActivityContent?.waiver[1]?.waiverPrice) {
              this.dmCardSpendRangeValue =
                this.resAcctActivityContent.waiver[1].waiverPrice;
            }
          }
        }
      }
      if (
        this.trackerData !== null &&
        typeof this.trackerData !== 'undefined'
      ) {
        if (
          this.trackerData.spendReqApplicableForCurrentYear &&
          !this.trackerData.internationalCustomer
        ) {
          this.showSpendRequirement = true;
        }
        this.showTracker = true;
        this.showSpendCriteria =
          this.trackerData.satisfiedCurrYearSpendCriteria;
        this.mileageReqChecked =
          this.trackerData.satisfiedCurrYearMileageCriteria;

        if (
          this.trackerData.currentYearCardSpend &&
          undefined !== this.trackerData.currentYearCardSpend.maxForCurrentTier
        ) {
          cardSpendRange = this.generateCardSpendRange(
            this.trackerData.currentYearCardSpend.availableBalance,
            false,
            false,
            this.trackerData.currentYearCardSpend.maxForCurrentTier
          );
        } else {
          cardSpendRange = this.generateCardSpendRange(0, false, false);
        }

        if (this.showSpendRequirement) {
          this.barTexts = {
            current: [
              this.resAcctActivityContent.mqmLabel +
                ' ' +
                this.addCommas(
                  this.trackerData.currentYearMQM.availableBalance
                ),
              this.resAcctActivityContent.mqsLabel +
                ' ' +
                this.addCommas(
                  this.trackerData.currentYearMQS.availableBalance
                ),
              this.resAcctActivityContent.mqdLabel +
                ' ' +
                this.resAcctActivityContent.currencySymbol +
                this.addCommas(
                  this.trackerData.currentYearMQD.availableBalance
                ),
              this.resAcctActivityContent.cardSpendLabel +
                ' ' +
                this.resAcctActivityContent.currencySymbol +
                cardSpendRange,
              this.resAcctActivityContent.mqmAccessibilityLabel +
                this.addCommas(
                  this.trackerData.currentYearMQM.availableBalance
                ) +
                this.resAcctActivityContent.miles,
              this.resAcctActivityContent.mqsAccessibilityLabel +
                this.addCommas(
                  this.trackerData.currentYearMQS.availableBalance
                ) +
                this.resAcctActivityContent.segments,
              this.resAcctActivityContent.mqdAccessibilityLabel +
                this.addCommas(
                  this.trackerData.currentYearMQD.availableBalance
                ),
              this.resAcctActivityContent.cardSpendLabel + cardSpendRange + '.'
            ],
            needed: [
              this.addCommas(
                this.trackerData.currentYearMQM.neededForNextTier
              ) +
                ' ' +
                this.resAcctActivityContent.to +
                ' ' +
                this.trackerData.trackingTowardsTierDesc,
              this.addCommas(
                this.trackerData.currentYearMQS.neededForNextTier
              ) +
                ' ' +
                this.resAcctActivityContent.to +
                ' ' +
                this.trackerData.trackingTowardsTierDesc,
              this.resAcctActivityContent.currencySymbol +
                this.addCommas(
                  this.trackerData.currentYearMQD.neededForNextTier
                ) +
                ' ' +
                this.resAcctActivityContent.to +
                ' ' +
                this.trackerData.trackingTowardsTierDesc,
              this.trackerData.enrolledForCoBrandCard
                ? this.resAcctActivityContent.currencySymbol +
                  this.addCommas(
                    this.generateCardSpendRange(
                      this.trackerData.currentYearCardSpend.neededForNextTier,
                      true,
                      false,
                      this.trackerData.currentYearCardSpend.maxForCurrentTier,
                      this.trackerData.currentYearCardSpend.availableBalance
                    )
                  ) +
                  ' ' +
                  this.resAcctActivityContent.goTo
                : ''
            ],
            max: [
              this.resAcctActivityContent.mqmLabel +
                ' ' +
                this.addCommas(
                  this.trackerData.currentYearMQM.maxForCurrentTier
                ),
              this.resAcctActivityContent.mqsLabel +
                ' ' +
                this.addCommas(
                  this.trackerData.currentYearMQS.maxForCurrentTier
                ),
              this.resAcctActivityContent.mqdLabel +
                ' ' +
                this.resAcctActivityContent.currencySymbol +
                this.addCommas(
                  this.trackerData.currentYearMQD.maxForCurrentTier
                ),
              ' ' +
                this.resAcctActivityContent.currencySymbol +
                this.cardSpendRangeValue,
              this.dmCardSpendRangeValue
                ? ' ' +
                  this.resAcctActivityContent.currencySymbol +
                  this.dmCardSpendRangeValue
                : ''
            ]
          };
        } else {
          this.barTexts = {
            current: [
              this.resAcctActivityContent.mqmLabel +
                ' ' +
                this.addCommas(
                  this.trackerData.currentYearMQM.availableBalance
                ),
              this.resAcctActivityContent.mqsLabel +
                ' ' +
                this.addCommas(
                  this.trackerData.currentYearMQS.availableBalance
                ),
              this.resAcctActivityContent.mqmAccessibilityLabel +
                this.addCommas(
                  this.trackerData.currentYearMQM.availableBalance
                ) +
                this.resAcctActivityContent.miles,
              this.resAcctActivityContent.mqsAccessibilityLabel +
                this.addCommas(
                  this.trackerData.currentYearMQS.availableBalance
                ) +
                this.resAcctActivityContent.segments
            ],
            needed: [
              this.addCommas(
                this.trackerData.currentYearMQM.neededForNextTier
              ) +
                ' ' +
                this.resAcctActivityContent.to +
                ' ' +
                this.trackerData.trackingTowardsTierDesc,
              this.addCommas(
                this.trackerData.currentYearMQS.neededForNextTier
              ) +
                ' ' +
                this.resAcctActivityContent.to +
                ' ' +
                this.trackerData.trackingTowardsTierDesc
            ],
            max: [
              this.resAcctActivityContent.mqmLabel +
                ' ' +
                this.addCommas(
                  this.trackerData.currentYearMQM.maxForCurrentTier
                ),
              this.resAcctActivityContent.mqsLabel +
                ' ' +
                this.addCommas(
                  this.trackerData.currentYearMQS.maxForCurrentTier
                )
            ]
          };
        }
        if (this.mileageReqChecked || this.trackerData?.nextProgramYear) {
          this.barTexts.needed[0] = '';
          this.barTexts.needed[1] = '';
        }
        if (this.showSpendCriteria || this.trackerData?.nextProgramYear) {
          this.barTexts.needed[2] = '';
          this.barTexts.needed[3] = '';
        }
        if (this.showSpendRequirement) {
          this.trackerOffscreenText = 'Your ' + this.barTexts.current[4];
          this.trackerOffscreenText +=
            this.barTexts.needed[0].length > 0
              ? ' Need' + this.barTexts.needed[0]
              : '';
          this.trackerOffscreenText += '. Your ' + this.barTexts.current[5]; // MQS
          this.trackerOffscreenText +=
            this.barTexts.needed[1].length > 0
              ? ' Need' + this.barTexts.needed[1]
              : '';
          this.trackerOffscreenText += '. Your ' + this.barTexts.current[6]; // MQD
          this.trackerOffscreenText +=
            this.barTexts.needed[2].length > 0
              ? ' Need' + this.barTexts.needed[2]
              : '';
          this.trackerOffscreenText += '. Your ' + this.barTexts.current[7]; // Card spend
          this.trackerOffscreenText +=
            this.barTexts.needed[3].length > 0
              ? ' Need' + this.barTexts.needed[3]
              : '';
        } else {
          this.trackerOffscreenText = 'Your ' + this.barTexts.current[2]; // MQM
          this.trackerOffscreenText +=
            this.barTexts.needed[0].length > 0
              ? ' Need' + this.barTexts.needed[0]
              : '';
          this.trackerOffscreenText += '. Your ' + this.barTexts.current[3]; // MQS
          this.trackerOffscreenText +=
            this.barTexts.needed[1].length > 0
              ? ' Need' + this.barTexts.needed[1]
              : '';
        }
      }
    }
  }

  generateCardSpendRange(
    value,
    isNeeded: boolean,
    isMax: boolean,
    maxTier?,
    spentValue?
  ) {
    let cardSpendRange: String;
    let baseMax = 25000;
    value = parseInt(value);
    maxTier = parseInt(maxTier);
    if (!this.trackerData.enrolledForCoBrandCard && !isMax) {
      cardSpendRange = '--';
      return cardSpendRange;
    }
    if (this.trackerData.showNewMQDWaiverCopy) {
      baseMax = maxTier;
    }
    let baseValue = baseMax / 1000;

    if (isNeeded && value === 0) {
      cardSpendRange = '0';
    } else if (value < 1000) {
      cardSpendRange = '0-1';
    } else if (isNeeded && value >= baseMax) {
      baseValue = (baseMax - spentValue) / 1000;
      cardSpendRange = baseValue - 1 + '-' + baseValue;
    } else if (value >= baseMax) {
      cardSpendRange = baseValue.toString();
    } else {
      let rangeStart = parseInt(value) / 1000;
      let rangeEnd = rangeStart + 1;
      if (isNeeded && parseInt(value) % 1000 === 0) {
        rangeStart--;
        rangeEnd--;
      }
      cardSpendRange = rangeStart + '-' + rangeEnd;
    }

    cardSpendRange = cardSpendRange + 'K';
    if (value >= baseMax && !isNeeded && !isMax) {
      cardSpendRange = cardSpendRange + '+';
    }
    return cardSpendRange;
  }

  addCommas(nStr) {
    nStr += '';
    const x = nStr.split('.');
    let x1 = x[0];
    const x2 = x.length > 1 ? '.' + x[1] : '';
    const rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
  }

  focusOutFunctionAccessibility(event) {
    const lastfocusElement =
      this.el.nativeElement.parentElement.parentElement.parentElement.querySelector(
        '.nav-tabs .mydelta-tab-link .nav-link'
      );
    lastfocusElement.focus();
    event.preventDefault();
  }

  removeMargin() {
    setTimeout(() => {
      const errorContainer = document.querySelector(
        '.tab-container .tab-content'
      );
      if (errorContainer) {
        errorContainer.classList.add('m-0');
      }
    }, 300);
  }

  openSkymilesPage() {
    if (this.exploreSkymilesLink) {
      if (this.upcomingTracker) {
        window.open(this.exploreSkymilesLink, '_blank');
      } else {
        window.location.href = this.exploreSkymilesLink;
      }
    }
  }

  ngOnDestroy() {
    if (this.contentHeaderFooterServiceSubscribe) {
      this.contentHeaderFooterServiceSubscribe.unsubscribe();
    }
    if (this.accountSummaryServiceSubscribe) {
      this.accountSummaryServiceSubscribe.unsubscribe();
    }
    if (this.trackerDataServiceSubscribe) {
      this.trackerDataServiceSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
  }
}
